import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=baae7a7c&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=baae7a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae7a7c",
  null
  
)

export default component.exports